/* **************************\
Component: Regex
Explanation:
Global regex constants to validate inputs for its standards
============================

\*************************** */
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
export const phoneNumberRegex = /^[789]\d{9}$/;
export const zipCode = /^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}/;
export const postalCodeRegex = /^[0-9]{6}$/;
export const nameRegex = /^[a-zA-Z]+$/;
export const userNameRegex = /^[a-zA-Z ]+$/;
export const orderIdRegex = /^[a-zA-Z0-9]+$/;
export const occasionRegex = /^[a-zA-z0-9? ,_-]{3,20}$/;
export const addressLine2RegEx = /^[a-zA-Z0-9 ,/#@\-().]+$/;
export const alphaNumericRegex = /[^a-zA-Z0-9 ]/;
export const AccountNameRegex = /^[A-Za-z0-9 ]{0,20}$/;
// Password
export const lowerCaseRegex = /.*[a-z].*/;
export const upperCaseRegex = /.*[A-Z].*/;
export const numberRegex = /.*[0-9].*/;
export const specialRegex = /^[!@#$%^&*()_~`-\w[\]{};:|,.<>/?]*$/;
export const allowedCharacterRegex = /^[a-zA-Z0-9!@#$%^&*()_~`-\w[\]{};:|,.<>/?]*$/;
export const cardNumRegex = /-/g;
export const priceRegegx = /\.00$/;
export const decimalPriceRegex = /[^\d\.]/g;
export const favouriteOrderRegex = /^[A-Za-z0-9 ]{0,20}$/;
export const addressRegex = /^([a-zA-Z0-9/ .,]){0,40}$/;
export const nameRegexAU = /^(?=.*[a-zA-Z].*)([a-zA-Z'-]{1,100})$/;
export const postalCodeRegExAU = /^(0[289]\d{2})|([1-7]\d{3})$/;
export const postalCodeRegexCA = /^(?!.*[DFIOQU])[A-VXY]\d[A-Z] ?\d[A-Z]\d$/;
export const errorMessageRegex = /^[a-zA-z0-9 ,_-]+$/;
export const postalCodeRegexZA = /^(?=.*[1-9].*)[0-9]{4}$/;
export const postalCodeRegexJP = /^(\d{3})-(\d{4})$/;
